import React, { Component } from 'react';
import _ from 'underscore';
import moment from 'moment';
import ga from 'analytics';

import Utils from 'utils/Utils.js';
import DateUtils from 'utils/DateUtils.js';

import ChallengeQuestionDateTime from './ChallengeQuestionDateTime.js';


class ChallengeQuestionDateTimeContainer extends Component {
    constructor(props) {
        super(props);
        this.initialState = {};
        this.state = this.initialState;
        this.onChange = this.onChange.bind(this);
    }
    componentWillMount() {
        if(!Boolean(this.props.challengeQuestion && this.props.challengeQuestion.data)) {
            this.onChange('selectedChallenge.challengeQuestions.' + this.props.index + '.data', this.getDefaultDate());
        }
    }
    onChange(name, date) {
        //console.log('ChallengeQuestionDateTime.onChange', date);
        this.props.onChange({target:{name:name, value:this.dateToString(date)}});
    }
    getDefaultDate() {
        var tag = this.props.selectedCategory.tag;
        if(tag==='log_workout') {
            return moment().subtract(1, 'hours').toDate();
        } else {
            return new Date();
        }
    }
    dateToString(date) {
        if(date==null) {
            return null;
        } else {
            return date.toISOString();
        }
    }
    render() {
        //console.log('ChallengeQuestionDateTime.render', this.props.challengeQuestion.data)
        var value = Boolean(this.props.challengeQuestion && this.props.challengeQuestion.data) ? moment(this.props.challengeQuestion.data).toDate() : null;
        return <ChallengeQuestionDateTime
                   {...this.props}
                   value={value}
                   onChangeDateTime={this.onChange}
                   />;
    }

}

export default ChallengeQuestionDateTimeContainer;



// WEBPACK FOOTER //
// ./src/modules/logs/ChallengeQuestionDateTimeContainer.js